<div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6">
    <div class="flex flex-0 justify-end h-8">
        <!-- <button mat-icon-button (click)="close(false)" [tabIndex]="-1"> -->
        <mat-icon class="icon-size-5 close-popup" [svgIcon]="'heroicons_outline:x'" (click)="close(false)">
        </mat-icon>
        <!-- </button> -->
    </div>
    <form class="flex flex-col flex-auto overflow-y-auto px-8 pb-8 gap-2" [formGroup]="componentForm">
        <span class="heading-h4">{{ 'PROFILE.TENANT.TITLE.TENANT' | transloco }}</span>
        <mat-form-field class="flex-auto pb-1">
            <mat-label>{{ 'PROFILE.TENANT.LABEL.TENANT' | transloco }}</mat-label>
            <mat-select formControlName="tenant" [disableOptionCentering]="true">
                <mat-option *ngFor="let item of lstTenant" [value]="item">
                    {{item.code}} - {{item.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="flex justify-end gap-2">
            <button mat-stroked-button (click)="close(false)" style="min-width: 120px;">
                {{ 'ACTION.BUTTON.CLOSE' | transloco }}
            </button>
            <button mat-flat-button [color]="'primary'" (click)="save($event)" style="min-width: 120px;">
                {{ 'GENERAL.SWITCH' | transloco }}
            </button>
        </div>
    </form>
</div>